import { TBossRankingsClientState } from '../libs/store';
import { TAction } from './types/action';

// Action Types
export const GET_BOSS_RANKINGS = 'GET_BOSS_RANKINGS';
export const SHOW_BOSS_RANKINGS_SPINNER = 'SHOW_BOSS_RANKINGS_SPINNER';

export type TGetBossRankingsAction = TAction<TBossRankingsClientState>;
export type TShowBossRankingsSpinner = TAction<boolean>;

// Action Creators
export function createActionGetBossRankings(bossRankings: TBossRankingsClientState): TGetBossRankingsAction {
  return {
    type: GET_BOSS_RANKINGS,
    payload: bossRankings
  };
}

export function createActionShowLoadingSpinner(show: boolean): TShowBossRankingsSpinner {
  return {
    type: SHOW_BOSS_RANKINGS_SPINNER,
    payload: show
  };
}
